// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/bgcupidnew.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/soundbarGif.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/speaker.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cupid-container {
  position: relative;
  width: 100vw;
  height: 100vh; /* Changed from min-height to fixed height */
  overflow: hidden; /* Prevent scrolling */
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf5 100%);
  transition: all 0.5s ease;
  margin: 0;
  padding: 0;
}

.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 64px); /* Fixed height minus navbar */
  width: 100%;
  padding: 1rem; /* Reduced padding */
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden; /* Prevent scrolling */
}

/* New layout with avatar */
.content-container.with-avatar {
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 0 3rem;
  max-width: 1400px;
  width: 100%;
}

.avatar-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 200px; /* Reduced min-width */
  max-width: 250px; /* Reduced max-width */
  margin-top: 0;
}

.avatar-image {
  width: 150px; /* Reduced size */
  height: 150px; /* Reduced size */
  object-fit: contain;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  padding: 12px; /* Reduced padding */
  box-shadow: 0 10px 25px rgba(102, 22, 205, 0.15);
  transition: transform 0.3s ease, filter 0.3s ease;
}

/* Avatar states */
.avatar-listening {
  animation: pulse 1.5s infinite alternate;
  filter: drop-shadow(0 0 15px rgba(102, 22, 205, 0.4));
}

.avatar-thinking {
  filter: drop-shadow(0 0 20px rgba(102, 22, 205, 0.6));
  animation: thinking 2s infinite;
}

.avatar-happy {
  transform: scale(1.1);
  filter: drop-shadow(0 0 25px rgba(102, 22, 205, 0.8));
  animation: happy 1s infinite alternate;
}

.avatar-talking {
  animation: talking 0.5s infinite alternate;
  filter: drop-shadow(0 0 15px rgba(102, 22, 205, 0.5));
}

/* Avatar animations */
@keyframes pulse {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.05);
  }
}

@keyframes thinking {
  0% {
    transform: translateY(0) rotate(0deg);
  }

  25% {
    transform: translateY(-5px) rotate(-2deg);
  }

  50% {
    transform: translateY(0) rotate(0deg);
  }

  75% {
    transform: translateY(5px) rotate(2deg);
  }

  100% {
    transform: translateY(0) rotate(0deg);
  }
}

@keyframes happy {
  0% {
    transform: scale(1.05) rotate(-3deg);
  }

  100% {
    transform: scale(1.1) rotate(3deg);
  }
}

@keyframes talking {
  0% {
    transform: translateY(0) scale(1);
  }

  100% {
    transform: translateY(-5px) scale(1.03);
  }
}

.avatar-enter {
  animation: avatarEnter 1.2s forwards;
}

@keyframes avatarEnter {
  0% {
    opacity: 0;
    transform: translateY(50px) scale(0.8);
  }

  70% {
    opacity: 1;
    transform: translateY(-10px) scale(1.05);
  }

  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.avatar-tip {
  position: absolute;
  top: -30px;
  right: -10px;
  background-color: white;
  color: #6616cd;
  padding: 12px 18px;
  border-radius: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  font-family: "Syne", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  max-width: 250px;
  z-index: 2;
  animation: tipPulse 2s infinite alternate;
}

@keyframes tipPulse {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.03);
  }
}

.avatar-tip:after {
  content: '';
  position: absolute;
  left: 20px;
  bottom: -10px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid white;
}

.processing-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15px;
  font-family: "Syne", sans-serif;
  color: #6616cd;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 10px 15px;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.loading-gif {
  width: 40px;
  height: 40px;
  margin-bottom: 5px;
}

.right-content {
  flex: 2 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 1.5rem; /* Reduced padding */
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 550px;
  max-height: 80vh; /* Limit maximum height */
  overflow: auto; /* Allow scrolling within this container if needed */
}

.text-input-container {
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.8rem;
  position: relative;
}

.interests-textarea {
  width: 100%;
  height: 120px; /* Fixed height */
  min-height: unset; /* Remove min-height */
  max-height: unset; /* Remove max-height */
  padding: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-family: "Syne", sans-serif;
  font-size: 1rem; /* Slightly reduced font size */
  resize: none;
  background-color: rgba(255, 255, 255, 0.95);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.interests-textarea:focus {
  outline: none;
  border-color: #6616cd;
  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.2);
}

.interests-textarea.recording-active {
  border-color: #6616cd;
  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.3);
  animation: textarea-pulse 2s infinite alternate;
}

@keyframes textarea-pulse {
  0% {
    box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);
  }

  100% {
    box-shadow: 0 0 0 5px rgba(102, 22, 205, 0.3);
  }
}

.button-group {
  display: flex;
  gap: 0.8rem; /* Reduced gap */
  margin-top: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.record-button,
.stop-button,
.submit-button {
  font-family: "Syne", sans-serif;
  font-size: 0.9rem; /* Reduced font size */
  font-weight: 500;
  padding: 0.7rem 1.4rem; /* Reduced padding */
  border: none;
  border-radius: 12px;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 200px;
}

.record-button {
  background: linear-gradient(135deg, #7928CA, #6616cd);
}

.stop-button {
  background: linear-gradient(135deg, #d62d2d, #ff5252);
}

.submit-button {
  background: linear-gradient(135deg, #6616cd, #5214a0);
}

.record-button:hover,
.submit-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(102, 22, 205, 0.3);
}

.stop-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(214, 45, 45, 0.3);
}

.record-button:active,
.stop-button:active,
.submit-button:active {
  transform: translateY(-1px);
}

.button-icon {
  font-size: 1.3rem;
}

.record-button:disabled,
.stop-button:disabled,
.submit-button:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Animation for record button */
.pulse-animation {
  animation: button-pulse 2s infinite;
}

@keyframes button-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(102, 22, 205, 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(102, 22, 205, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(102, 22, 205, 0);
  }
}

/* Animation for recording indicator */
.recording-pulse {
  animation: recording-pulse 1s infinite alternate;
}

@keyframes recording-pulse {
  0% {
    box-shadow: 0 8px 15px rgba(214, 45, 45, 0.3);
  }

  100% {
    box-shadow: 0 8px 20px rgba(214, 45, 45, 0.5);
  }
}

/* Background animation during recording */
.bg-pulse {
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7f5 100%);
  animation: bg-pulse 4s infinite alternate;
}

@keyframes bg-pulse {
  0% {
    background-color: rgba(255, 255, 255, 1);
  }

  100% {
    background-color: rgba(240, 240, 255, 1);
  }
}

.default-cupid-background {
  background-size: cover;
  transition: all 0.5s ease;
  position: relative;
}

.default-cupid-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  opacity: 0.1;
  z-index: -1;
}

.greeting {
  font-family: "Syne", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem; /* Reduced font size */
  margin-bottom: 0.5rem; /* Reduced margin */
  color: #6616cd;
  text-align: center;
}

.instructions {
  font-family: "Syne", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 0.9rem; /* Reduced font size */
  margin-bottom: 0.5rem; /* Reduced margin */
  text-align: center;
  color: #444;
  max-width: 600px;
  line-height: 1.3;
}

/* Media Queries */
@media (max-width: 992px) {
  .content-container.with-avatar {
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    height: -moz-fit-content;
    height: fit-content;
  }

  .avatar-container {
    margin: 0;
    transform: scale(0.8); /* Scale down avatar on mobile */
  }

  .right-content {
    padding: 1rem;
    max-height: calc(70vh - 64px);
  }

  .interests-textarea {
    height: 100px;
  }
}

@media (max-width: 768px) {
  .greeting {
    font-size: 1.7rem;
  }

  .instructions {
    font-size: 1rem;
  }

  .interests-textarea {
    min-height: 120px;
  }

  .button-group {
    flex-direction: column;
    gap: 0.8rem;
  }

  .record-button,
  .stop-button,
  .submit-button {
    width: 100%;
    padding: 0.8rem 1rem;
  }

  .right-content {
    padding: 1.5rem;
  }
}

/* Keep existing utility classes */
.button-group-horizontal {
  margin-top: 0.8rem;
  /* Reduced margin */
}

.alternate-cupid-background {
  background: white;
}

.flexbox-column {
  display: flex;
}

.flexbox-row {
  display: flex;
  flex-direction: column;
}

.height-80vh {
  height: 80vh;
}

.width-100vw {
  width: 100vw;
}

.width-40vw {
  width: 40vw;
}

.margin-right-20vw {
  margin-right: 20vw;
}

.width-50vw {
  width: 50vw;
}

.padding-top-5vh {
  padding-top: 5vh;
}

.height-40vh {
  height: 40vh;
}

.height-30vh {
  height: 30vh;
}

.height-50vh {
  height: 50vh;
}

.additional-content {
  width: 40vw;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.center-flexbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.begin-flexbox {
  display: flex;

  align-items: start;
  justify-content: center;
}

.begin-message,
.retry-message,
.stop-message {
  font-family: "Syne", sans-serif;
  font-size: 2.8vh;

  padding: 0vw 6vw;
}

.retry-button {
  font-family: "Syne", sans-serif;
  font-size: 3vh;
  padding: 0.7rem 1.5rem;
  margin: 2vh;
  border: none;
  border-radius: 0.5rem;

  background-color: white;
  color: #6616cd;
  border: 2px solid #6616cd;
  cursor: pointer;
}

.retry-button:disabled {
  border: 2px solid #cccccc;
  color: #cccccc;
}

.begin-button,
.submit-button,
.stop-button {
  font-family: "Syne", sans-serif;
  font-size: 3vh;
  padding: 0.7rem 1.5rem;
  margin: 1vh;
  border: none;
  border-radius: 0.5rem;
  background-color: #6616cd;
  color: #ffffff;

  cursor: pointer;
}

.retry-button,
.submit-button {
  width: 15vw;
}

.begin-button,
.stop-button {
  width: 20vw;
}

.begin-button:disabled,
.submit-button:disabled,
.stop-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.audio-bar {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100% 100%;
  height: 5vh;
  width: 5vh;
  padding: 2vh;
}

.white-border-button {
  border: 4px solid white;
  border-radius: 13px;
}

.speaker-bar {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100% 100%;
  height: 9vh;
  width: 9vh;
  padding: 2vh;
}

.padding-2vh {
  padding: 2vh;
}

.padding-left-5vw {
  padding-left: 5vw;
}

.width-20vw {
  width: 20vw;
}

.cupid-background {
  /* background: url("../../assets/cupid.png"); */
  background-repeat: no-repeat;
  background-position: 50% 48%;
  background-size: 15vw 15vw;
}

.width-40-100vw {
  width: 40vw;
}

.cupid-image {
  width: 20vw;
  height: 20vw;
}

.width-20-100vw {
  width: 20vw;
}

.height-80-20vh {
  height: 80vh;
}

.padding-5-0vh-top {
  padding-top: 5vh;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-up {
  animation: fadeUp 0.5s ease-out;
}

.avatar-bounce {
  animation: bounce 1s ease;
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-20px);
  }

  60% {
    transform: translateY(-10px);
  }
}

.textarea-highlight {
  animation: highlight 0.5s ease;
}

@keyframes highlight {
  0% {
    box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);
  }

  50% {
    box-shadow: 0 0 0 5px rgba(102, 22, 205, 0.6);
  }

  100% {
    box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.3);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Authentication/SignupAvatar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa,EAAE,4CAA4C;EAC3D,gBAAgB,EAAE,sBAAsB;EACxC,6DAA6D;EAC7D,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B,EAAE,8BAA8B;EAC1D,WAAW;EACX,aAAa,EAAE,oBAAoB;EACnC,cAAc;EACd,sBAAsB;EACtB,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB,EAAE,sBAAsB;EACxC,gBAAgB,EAAE,sBAAsB;EACxC,aAAa;AACf;;AAEA;EACE,YAAY,EAAE,iBAAiB;EAC/B,aAAa,EAAE,iBAAiB;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa,EAAE,oBAAoB;EACnC,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA,kBAAkB;AAClB;EACE,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe,EAAE,oBAAoB;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB,EAAE,yBAAyB;EAC3C,cAAc,EAAE,oDAAoD;AACtE;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,iBAAiB;EAChC,iBAAiB,EAAE,sBAAsB;EACzC,iBAAiB,EAAE,sBAAsB;EACzC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe,EAAE,+BAA+B;EAChD,YAAY;EACZ,2CAA2C;EAC3C,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,aAAa;EACb,WAAW,EAAE,gBAAgB;EAC7B,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,+BAA+B;EAC/B,iBAAiB,EAAE,sBAAsB;EACzC,gBAAgB;EAChB,sBAAsB,EAAE,oBAAoB;EAC5C,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA,sCAAsC;AACtC;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA,0CAA0C;AAC1C;EACE,6DAA6D;EAC7D,yCAAyC;AAC3C;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,sBAAsB;EACzC,qBAAqB,EAAE,mBAAmB;EAC1C,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,sBAAsB;EACzC,qBAAqB,EAAE,mBAAmB;EAC1C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,qBAAqB,EAAE,gCAAgC;EACzD;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;;IAGE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;;EAEX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;;EAEb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;EAGE,+BAA+B;EAC/B,gBAAgB;;EAEhB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qBAAqB;;EAErB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,+BAA+B;EAC/B,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;;EAEd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mDAA+C;EAC/C,0BAA0B;EAC1B,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mDAA2C;EAC3C,0BAA0B;EAC1B,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;EAC/C;AACF","sourcesContent":[".cupid-container {\n  position: relative;\n  width: 100vw;\n  height: 100vh; /* Changed from min-height to fixed height */\n  overflow: hidden; /* Prevent scrolling */\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf5 100%);\n  transition: all 0.5s ease;\n  margin: 0;\n  padding: 0;\n}\n\n.content-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 64px); /* Fixed height minus navbar */\n  width: 100%;\n  padding: 1rem; /* Reduced padding */\n  margin: 0 auto;\n  box-sizing: border-box;\n  overflow: hidden; /* Prevent scrolling */\n}\n\n/* New layout with avatar */\n.content-container.with-avatar {\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  padding: 0 3rem;\n  max-width: 1400px;\n  width: 100%;\n}\n\n.avatar-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  min-width: 200px; /* Reduced min-width */\n  max-width: 250px; /* Reduced max-width */\n  margin-top: 0;\n}\n\n.avatar-image {\n  width: 150px; /* Reduced size */\n  height: 150px; /* Reduced size */\n  object-fit: contain;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 12px; /* Reduced padding */\n  box-shadow: 0 10px 25px rgba(102, 22, 205, 0.15);\n  transition: transform 0.3s ease, filter 0.3s ease;\n}\n\n/* Avatar states */\n.avatar-listening {\n  animation: pulse 1.5s infinite alternate;\n  filter: drop-shadow(0 0 15px rgba(102, 22, 205, 0.4));\n}\n\n.avatar-thinking {\n  filter: drop-shadow(0 0 20px rgba(102, 22, 205, 0.6));\n  animation: thinking 2s infinite;\n}\n\n.avatar-happy {\n  transform: scale(1.1);\n  filter: drop-shadow(0 0 25px rgba(102, 22, 205, 0.8));\n  animation: happy 1s infinite alternate;\n}\n\n.avatar-talking {\n  animation: talking 0.5s infinite alternate;\n  filter: drop-shadow(0 0 15px rgba(102, 22, 205, 0.5));\n}\n\n/* Avatar animations */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(1.05);\n  }\n}\n\n@keyframes thinking {\n  0% {\n    transform: translateY(0) rotate(0deg);\n  }\n\n  25% {\n    transform: translateY(-5px) rotate(-2deg);\n  }\n\n  50% {\n    transform: translateY(0) rotate(0deg);\n  }\n\n  75% {\n    transform: translateY(5px) rotate(2deg);\n  }\n\n  100% {\n    transform: translateY(0) rotate(0deg);\n  }\n}\n\n@keyframes happy {\n  0% {\n    transform: scale(1.05) rotate(-3deg);\n  }\n\n  100% {\n    transform: scale(1.1) rotate(3deg);\n  }\n}\n\n@keyframes talking {\n  0% {\n    transform: translateY(0) scale(1);\n  }\n\n  100% {\n    transform: translateY(-5px) scale(1.03);\n  }\n}\n\n.avatar-enter {\n  animation: avatarEnter 1.2s forwards;\n}\n\n@keyframes avatarEnter {\n  0% {\n    opacity: 0;\n    transform: translateY(50px) scale(0.8);\n  }\n\n  70% {\n    opacity: 1;\n    transform: translateY(-10px) scale(1.05);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.avatar-tip {\n  position: absolute;\n  top: -30px;\n  right: -10px;\n  background-color: white;\n  color: #6616cd;\n  padding: 12px 18px;\n  border-radius: 20px;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);\n  font-family: \"Syne\", sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  max-width: 250px;\n  z-index: 2;\n  animation: tipPulse 2s infinite alternate;\n}\n\n@keyframes tipPulse {\n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(1.03);\n  }\n}\n\n.avatar-tip:after {\n  content: '';\n  position: absolute;\n  left: 20px;\n  bottom: -10px;\n  width: 0;\n  height: 0;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid white;\n}\n\n.processing-indicator {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 15px;\n  font-family: \"Syne\", sans-serif;\n  color: #6616cd;\n  background-color: rgba(255, 255, 255, 0.8);\n  padding: 10px 15px;\n  border-radius: 15px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.loading-gif {\n  width: 40px;\n  height: 40px;\n  margin-bottom: 5px;\n}\n\n.right-content {\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.9);\n  padding: 1.5rem; /* Reduced padding */\n  border-radius: 20px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 550px;\n  max-height: 80vh; /* Limit maximum height */\n  overflow: auto; /* Allow scrolling within this container if needed */\n}\n\n.text-input-container {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0.8rem;\n  position: relative;\n}\n\n.interests-textarea {\n  width: 100%;\n  height: 120px; /* Fixed height */\n  min-height: unset; /* Remove min-height */\n  max-height: unset; /* Remove max-height */\n  padding: 1rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 12px;\n  font-family: \"Syne\", sans-serif;\n  font-size: 1rem; /* Slightly reduced font size */\n  resize: none;\n  background-color: rgba(255, 255, 255, 0.95);\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.interests-textarea:focus {\n  outline: none;\n  border-color: #6616cd;\n  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.2);\n}\n\n.interests-textarea.recording-active {\n  border-color: #6616cd;\n  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.3);\n  animation: textarea-pulse 2s infinite alternate;\n}\n\n@keyframes textarea-pulse {\n  0% {\n    box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);\n  }\n\n  100% {\n    box-shadow: 0 0 0 5px rgba(102, 22, 205, 0.3);\n  }\n}\n\n.button-group {\n  display: flex;\n  gap: 0.8rem; /* Reduced gap */\n  margin-top: 0.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.record-button,\n.stop-button,\n.submit-button {\n  font-family: \"Syne\", sans-serif;\n  font-size: 0.9rem; /* Reduced font size */\n  font-weight: 500;\n  padding: 0.7rem 1.4rem; /* Reduced padding */\n  border: none;\n  border-radius: 12px;\n  color: #ffffff;\n  cursor: pointer;\n  transition: transform 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  min-width: 200px;\n}\n\n.record-button {\n  background: linear-gradient(135deg, #7928CA, #6616cd);\n}\n\n.stop-button {\n  background: linear-gradient(135deg, #d62d2d, #ff5252);\n}\n\n.submit-button {\n  background: linear-gradient(135deg, #6616cd, #5214a0);\n}\n\n.record-button:hover,\n.submit-button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 15px rgba(102, 22, 205, 0.3);\n}\n\n.stop-button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 15px rgba(214, 45, 45, 0.3);\n}\n\n.record-button:active,\n.stop-button:active,\n.submit-button:active {\n  transform: translateY(-1px);\n}\n\n.button-icon {\n  font-size: 1.3rem;\n}\n\n.record-button:disabled,\n.stop-button:disabled,\n.submit-button:disabled {\n  background: #cccccc;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Animation for record button */\n.pulse-animation {\n  animation: button-pulse 2s infinite;\n}\n\n@keyframes button-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(102, 22, 205, 0.7);\n  }\n\n  70% {\n    box-shadow: 0 0 0 10px rgba(102, 22, 205, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(102, 22, 205, 0);\n  }\n}\n\n/* Animation for recording indicator */\n.recording-pulse {\n  animation: recording-pulse 1s infinite alternate;\n}\n\n@keyframes recording-pulse {\n  0% {\n    box-shadow: 0 8px 15px rgba(214, 45, 45, 0.3);\n  }\n\n  100% {\n    box-shadow: 0 8px 20px rgba(214, 45, 45, 0.5);\n  }\n}\n\n/* Background animation during recording */\n.bg-pulse {\n  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7f5 100%);\n  animation: bg-pulse 4s infinite alternate;\n}\n\n@keyframes bg-pulse {\n  0% {\n    background-color: rgba(255, 255, 255, 1);\n  }\n\n  100% {\n    background-color: rgba(240, 240, 255, 1);\n  }\n}\n\n.default-cupid-background {\n  background-size: cover;\n  transition: all 0.5s ease;\n  position: relative;\n}\n\n.default-cupid-background::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url(\"../../assets/bgcupidnew.png\");\n  background-size: cover;\n  background-position: center;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.greeting {\n  font-family: \"Syne\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.5rem; /* Reduced font size */\n  margin-bottom: 0.5rem; /* Reduced margin */\n  color: #6616cd;\n  text-align: center;\n}\n\n.instructions {\n  font-family: \"Syne\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 0.9rem; /* Reduced font size */\n  margin-bottom: 0.5rem; /* Reduced margin */\n  text-align: center;\n  color: #444;\n  max-width: 600px;\n  line-height: 1.3;\n}\n\n/* Media Queries */\n@media (max-width: 992px) {\n  .content-container.with-avatar {\n    flex-direction: column;\n    align-items: center;\n    padding: 1rem;\n    height: fit-content;\n  }\n\n  .avatar-container {\n    margin: 0;\n    transform: scale(0.8); /* Scale down avatar on mobile */\n  }\n\n  .right-content {\n    padding: 1rem;\n    max-height: calc(70vh - 64px);\n  }\n\n  .interests-textarea {\n    height: 100px;\n  }\n}\n\n@media (max-width: 768px) {\n  .greeting {\n    font-size: 1.7rem;\n  }\n\n  .instructions {\n    font-size: 1rem;\n  }\n\n  .interests-textarea {\n    min-height: 120px;\n  }\n\n  .button-group {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .record-button,\n  .stop-button,\n  .submit-button {\n    width: 100%;\n    padding: 0.8rem 1rem;\n  }\n\n  .right-content {\n    padding: 1.5rem;\n  }\n}\n\n/* Keep existing utility classes */\n.button-group-horizontal {\n  margin-top: 0.8rem;\n  /* Reduced margin */\n}\n\n.alternate-cupid-background {\n  background: white;\n}\n\n.flexbox-column {\n  display: flex;\n}\n\n.flexbox-row {\n  display: flex;\n  flex-direction: column;\n}\n\n.height-80vh {\n  height: 80vh;\n}\n\n.width-100vw {\n  width: 100vw;\n}\n\n.width-40vw {\n  width: 40vw;\n}\n\n.margin-right-20vw {\n  margin-right: 20vw;\n}\n\n.width-50vw {\n  width: 50vw;\n}\n\n.padding-top-5vh {\n  padding-top: 5vh;\n}\n\n.height-40vh {\n  height: 40vh;\n}\n\n.height-30vh {\n  height: 30vh;\n}\n\n.height-50vh {\n  height: 50vh;\n}\n\n.additional-content {\n  width: 40vw;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.center-flexbox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.begin-flexbox {\n  display: flex;\n\n  align-items: start;\n  justify-content: center;\n}\n\n.begin-message,\n.retry-message,\n.stop-message {\n  font-family: \"Syne\", sans-serif;\n  font-size: 2.8vh;\n\n  padding: 0vw 6vw;\n}\n\n.retry-button {\n  font-family: \"Syne\", sans-serif;\n  font-size: 3vh;\n  padding: 0.7rem 1.5rem;\n  margin: 2vh;\n  border: none;\n  border-radius: 0.5rem;\n\n  background-color: white;\n  color: #6616cd;\n  border: 2px solid #6616cd;\n  cursor: pointer;\n}\n\n.retry-button:disabled {\n  border: 2px solid #cccccc;\n  color: #cccccc;\n}\n\n.begin-button,\n.submit-button,\n.stop-button {\n  font-family: \"Syne\", sans-serif;\n  font-size: 3vh;\n  padding: 0.7rem 1.5rem;\n  margin: 1vh;\n  border: none;\n  border-radius: 0.5rem;\n  background-color: #6616cd;\n  color: #ffffff;\n\n  cursor: pointer;\n}\n\n.retry-button,\n.submit-button {\n  width: 15vw;\n}\n\n.begin-button,\n.stop-button {\n  width: 20vw;\n}\n\n.begin-button:disabled,\n.submit-button:disabled,\n.stop-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.audio-bar {\n  background: url(\"../../assets/soundbarGif.gif\");\n  background-size: 100% 100%;\n  height: 5vh;\n  width: 5vh;\n  padding: 2vh;\n}\n\n.white-border-button {\n  border: 4px solid white;\n  border-radius: 13px;\n}\n\n.speaker-bar {\n  background: url(\"../../assets/speaker.gif\");\n  background-size: 100% 100%;\n  height: 9vh;\n  width: 9vh;\n  padding: 2vh;\n}\n\n.padding-2vh {\n  padding: 2vh;\n}\n\n.padding-left-5vw {\n  padding-left: 5vw;\n}\n\n.width-20vw {\n  width: 20vw;\n}\n\n.cupid-background {\n  /* background: url(\"../../assets/cupid.png\"); */\n  background-repeat: no-repeat;\n  background-position: 50% 48%;\n  background-size: 15vw 15vw;\n}\n\n.width-40-100vw {\n  width: 40vw;\n}\n\n.cupid-image {\n  width: 20vw;\n  height: 20vw;\n}\n\n.width-20-100vw {\n  width: 20vw;\n}\n\n.height-80-20vh {\n  height: 80vh;\n}\n\n.padding-5-0vh-top {\n  padding-top: 5vh;\n}\n\n@keyframes fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-up {\n  animation: fadeUp 0.5s ease-out;\n}\n\n.avatar-bounce {\n  animation: bounce 1s ease;\n}\n\n@keyframes bounce {\n\n  0%,\n  20%,\n  50%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n\n  40% {\n    transform: translateY(-20px);\n  }\n\n  60% {\n    transform: translateY(-10px);\n  }\n}\n\n.textarea-highlight {\n  animation: highlight 0.5s ease;\n}\n\n@keyframes highlight {\n  0% {\n    box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);\n  }\n\n  50% {\n    box-shadow: 0 0 0 5px rgba(102, 22, 205, 0.6);\n  }\n\n  100% {\n    box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.3);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
